import React from 'react';
import { TextField, Typography, Paper } from '@mui/material';

const SessionSummaryCard = ({ sessionSummary, onFieldChange }) => {
  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography
        variant='h6'
        sx={{ mb: 2, color: '#9291f0', fontWeight: 600 }}
      >
        Session Summary
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={6}
        label='Session Summary'
        placeholder='Enter your session summary here...'
        value={sessionSummary || ''}
        onChange={(e) =>
          onFieldChange('sessionSummary', e.target.value)
        }
        variant='outlined'
      />
    </Paper>
  );
};

export default SessionSummaryCard;

